export interface LineItem {
  id: string;
  description: string;
  quantity: number;
  price: number;
  tax_percent: number;
  discount_percent: number;
  product_code: string;
  unit_code: string;
}

export interface ClientData {
  client_id: number;
  business_name: string;
  client_name: string;
  client_last_name: string;
  document_type: string;
  document: string;
  document_dv: string;
  person_type: string;
  tax_regime: string;
  client_address: string;
  city_name: string;
  city_code: string;
  department_name: string;
  department_code: string;
  postal_code: string;
  client_email: string;
  client_phone: string;
}

export function mapClientToBuyer(client: ClientData) {
  return {
    nit: client.document,
    name: client.business_name || `${client.client_name} ${client.client_last_name}`.trim(),
    first_name: client.client_name || '',
    last_name: client.client_last_name || '',
    document_type: client.document_type || '13',
    nit_dv: client.document_dv || '',
    person_type: client.person_type || '2',
    tax_regime: client.tax_regime || 'O-99',
    address: client.client_address || '',
    city_code: client.city_code || '',
    city_name: client.city_name || '',
    department_code: client.department_code || '',
    department: client.department_name || '',
    postal_code: client.postal_code || client.city_code || '',
    email: client.client_email || '',
    phone: client.client_phone || '',
  };
}

export function calculateTotals(items: LineItem[]) {
  const subtotal = items.reduce((sum, i) => {
    const discounted = i.quantity * i.price * (1 - (i.discount_percent || 0) / 100);
    return sum + discounted;
  }, 0);
  const totalTax = items.reduce((sum, i) => {
    const discounted = i.quantity * i.price * (1 - (i.discount_percent || 0) / 100);
    return sum + discounted * (i.tax_percent / 100);
  }, 0);
  const total = subtotal + totalTax;
  return { subtotal, totalTax, total };
}

export function validateInvoiceForm(client: ClientData | null, items: LineItem[]): string[] {
  const errors: string[] = [];
  if (!client) errors.push('Debe seleccionar un cliente');
  if (items.length === 0) errors.push('Debe agregar al menos un ítem');
  items.forEach((item, i) => {
    if (!item.description.trim()) errors.push(`Ítem ${i + 1}: descripción requerida`);
    if (item.quantity <= 0) errors.push(`Ítem ${i + 1}: cantidad debe ser mayor a 0`);
    if (item.price <= 0) errors.push(`Ítem ${i + 1}: precio debe ser mayor a 0`);
  });
  return errors;
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(value);
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 9);
}
